module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAtklEQVQ4jWNgGGjAyMDAwLBp06b/5Gj28/NjZIFxfH19SdK8efNmBgYGBgYWdImzhy4yhG25yvD/3z+Gxd46DNaOBngNYkIX+HL7PoO4sBSDnKQsw9db9wi6hJGBgYGBIXYJPAyU/3xi2Dk1kYGZmYnBI2Muw00WPty6F8cwYnjhLgsfQ/vELQzcrIz4NUMBhgEMDAwMc+/9JKgRBhgZGBgY3sqokBWNwk/uMGIEIqlg4A0YBgAAwFUpOt6bFUQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SL.png
// module id = 1264
// module chunks = 0